import { FC } from 'react';

import { CopyableText } from '@/common/components';

import { SearchConsoleAnalyticsQueriesDimension } from '@/modules/DomainsApi';

interface Props {
  value: SearchConsoleAnalyticsQueriesDimension['key'];
}

export const QueriesLabel: FC<Props> = ({ value }) => {
  return <CopyableText textToCopy={ value }>{ value }</CopyableText>;
};
